import { Chip } from "@heroui/react";

import { ImageTile } from "@/components/kit";
import { Product } from "@/types";

interface ProductCardProps {
  product: Product;
}

/** The product as shown in the view dialog: picture, names, price, stock and description. */
export const ProductCard = ({ product }: ProductCardProps) => {
  return (
    <div className="flex flex-col gap-4">
      <ImageTile size="hero" src={product.images?.[0]} />
      <div className="flex items-start justify-between gap-4">
        <div className="flex min-w-0 flex-col gap-0.5">
          <h3 className="text-base font-semibold text-(--foreground)">{product.name}</h3>
          <p className="text-muted text-sm" dir="rtl">
            {product.nameAr}
          </p>
        </div>
        <div className="flex shrink-0 flex-col items-end gap-1.5">
          <span className="text-base font-semibold text-(--foreground) tabular-nums">
            AED {product.price.toFixed(2)}
          </span>
          <Chip color={product.inStock ? "success" : "danger"} variant="soft">
            {product.inStock ? "In Stock" : "Out of stock"}
          </Chip>
        </div>
      </div>
      {product.description ? (
        <p className="text-muted text-sm">{product.description}</p>
      ) : null}
    </div>
  );
};
